import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './EngagementPanel.css';
import Stats from '../../../../Components/Stats/Stats';
import TabBar from '../../../../Components/TabBar/TabBar';
import { EngagementTabId } from '../../../../Utils/Constants';
import EngagementModal from './EngagementModal/EngagementModal';
import { connect } from 'react-redux';
import { actions as sessionPollActions } from '../../../../Reducks/SessionPoll';
import { getPercentageSafe } from '../../../../Utils/MathUtils';
import { getTimeInHrMin } from '../../../../Utils/DateFormatUtils';
import moment from 'moment-timezone';
import { actions as sessionSurveysActions } from '../../../../Reducks/SessionSurvey';
import { actions as sessionQuestionsActions } from '../../../../Reducks/SessionQuestions';
import { trackAnalyticsFeature } from '../../../../Telemetry/Mixpanel/Features/analyticsTracker';
import {
  ENGAGEMENT_POLLS_TAB,
  ENGAGEMENT_QANDA_TAB,
  ENGAGEMENT_SURVEY_TAB,
  SESSION_DETAILS,
  VALUE_ADD,
  VIEW_ENGAGEMENT_RESULTS
} from '../../../../Telemetry/Mixpanel/Constants/mixpanelConstants';

export class EngagementPanel extends Component {
  static contextTypes = {
    t: PropTypes.func
  };
  static propTypes = {
    isBig: PropTypes.bool,
    webinarKey: PropTypes.string,
    sessionKey: PropTypes.string,
    webinarNameHeading: PropTypes.any,
    reduced_session_details: PropTypes.object,
    reduced_session_surveys: PropTypes.object,
    getSessionPolls: PropTypes.func,
    getSessionSurvey: PropTypes.func,
    getSessionQuestions: PropTypes.func
  };
  constructor() {
    super();
    this.state = {
      activeTabId: EngagementTabId.POLL_TAB,
      isEngagementModalOpen: false
    };
  }

  componentDidMount() {
    const { webinarKey, sessionKey, getSessionPolls, getSessionSurvey, getSessionQuestions } = this.props;
    getSessionPolls(webinarKey, sessionKey);
    getSessionSurvey(webinarKey, sessionKey);
    getSessionQuestions(sessionKey);
  }

  render() {
    const { t } = this.context;
    const { activeTabId, isEngagementModalOpen } = this.state;
    const { webinarNameHeading, webinarKey, sessionKey, isBig } = this.props;
    const { stats: sessionStats, sessionDetails } = this.props.reduced_session_details;

    const tabBar = <TabBar tabContentMetadata={this.buildTabContentMetadata()} activeTabId={activeTabId} />;
    const statsRow = this.showStatsBasedOnEngagementType(activeTabId, sessionDetails, sessionStats);
    return (
      <div className="sessionDetailsEngagementPanel">
        <div className="panelHeader">
          <div className="panelTitle">{t('engagement.engagement')}</div>
        </div>
        <div className="panelBody">
          {tabBar}
          {statsRow}
        </div>
        <div className="panelFooter">
          <EngagementModal
            isBig={isBig}
            webinarKey={webinarKey}
            sessionKey={sessionKey}
            isOpen={isEngagementModalOpen}
            toggle={this.toggleEngagementModal}
            engagementTabs={tabBar}
            activeTabId={activeTabId}
            statsRow={statsRow}
            webinarNameHeading={webinarNameHeading}
          />
          <button className="custom-buttons-chameleon outline-button" onClick={this.toggleEngagementModal}>
            {t('engagement.viewResultsButton')}
          </button>
        </div>
      </div>
    );
  }

  switchTab = (activeTabId, mixPanelTabType) => {
    trackAnalyticsFeature(VALUE_ADD, SESSION_DETAILS, mixPanelTabType);
    this.setState({ activeTabId });
  };
  toggleEngagementModal = () => {
    trackAnalyticsFeature(VALUE_ADD, SESSION_DETAILS, VIEW_ENGAGEMENT_RESULTS);
    this.setState(prevState => ({ isEngagementModalOpen: !prevState.isEngagementModalOpen }));
  };
  buildTabContentMetadata = () => {
    const { t } = this.context;
    return [
      {
        id: EngagementTabId.POLL_TAB,
        title: t('engagement.polls'),
        onClick: () => this.switchTab(EngagementTabId.POLL_TAB, ENGAGEMENT_POLLS_TAB)
      },
      {
        id: EngagementTabId.SURVEY_TAB,
        title: t('engagement.survey'),
        onClick: () => this.switchTab(EngagementTabId.SURVEY_TAB, ENGAGEMENT_SURVEY_TAB)
      },
      {
        id: EngagementTabId.QANDA_TAB,
        title: t('engagement.qanda'),
        onClick: () => this.switchTab(EngagementTabId.QANDA_TAB, ENGAGEMENT_QANDA_TAB)
      }
    ];
  };
  showStatsBasedOnEngagementType = (activeTabId, sessionDetails, sessionStats) => {
    const { t } = this.context;
    const { surveys = [] } = this.props.reduced_session_surveys;
    const pollsArray = [
      {
        uniqueId: 'pollQuestionCount_polls',
        subText: t('engagement.pollQuestionCount'),
        title: sessionStats.pollQuestionCount
      },
      {
        uniqueId: 'attendeeCount_polls',
        subText: t('engagement.totalAttendees'),
        title: sessionStats.attendees
      },
      {
        uniqueId: 'avgResponseRate_polls',
        subText: t('engagement.averageResponseRate'),
        title: `${getPercentageSafe(
          sessionStats.attendeePollResponseCount,
          sessionStats.pollQuestionCount * sessionStats.attendees
        )} %`
      }
    ];

    const durationInMillis = moment
      .duration(moment(sessionDetails.endTime).diff(sessionDetails.startTime))
      .asMilliseconds();

    const qAndAArray = [
      {
        uniqueId: 'questionCount_qanda',
        subText: t('engagement.questionCount'),
        title: sessionStats.sessionQAndACount
      },
      {
        uniqueId: 'attendeeCount_qanda',
        subText: t('engagement.totalAttendees'),
        title: sessionStats.attendees
      },
      {
        uniqueId: 'sessionDuration_qanda',
        subText: t('engagement.sessionDuration'),
        title: getTimeInHrMin(durationInMillis)
      }
    ];

    const surveyArray = [
      {
        uniqueId: 'surveyQuestions_survey',
        subText: t('engagement.surveyQuestionCount'),
        title: surveys.length
      },
      {
        uniqueId: 'attendeeCount_survey',
        subText: t('engagement.totalAttendees'),
        title: sessionStats.attendees
      },
      {
        uniqueId: 'avgResponseRate_survey',
        subText: t('engagement.averageResponseRate'),
        title: `${getPercentageSafe(sessionStats.attendeeSurveyResponseCount, sessionStats.attendees)} %`
      }
    ];

    let cardsArray = [];
    switch (activeTabId) {
      case EngagementTabId.POLL_TAB:
        cardsArray = pollsArray;
        break;
      case EngagementTabId.SURVEY_TAB:
        cardsArray = surveyArray;
        break;
      case EngagementTabId.QANDA_TAB:
        cardsArray = qAndAArray;
        break;
      default:
        console.warn('unknown activetab ignoring it');
        cardsArray = [];
    }
    return <Stats contents={cardsArray} />;
  };
}
export default connect(
  state => ({
    reduced_session_details: state.reduced_session_details,
    reduced_session_surveys: state.reduced_session_surveys
  }),
  {
    getSessionPolls: sessionPollActions.getSessionPolls,
    getSessionSurvey: sessionSurveysActions.getSessionSurvey,
    getSessionQuestions: sessionQuestionsActions.getSessionQuestions
  }
)(EngagementPanel);



// WEBPACK FOOTER //
// ./src/GoToWebinar/Sessions/SessionDetails/Engagement/EngagementPanel.js